import presignedExport from '../../../services/auth/presignedExport';

export default function(angularModule) {
  angularModule.factory('billingAccountsService', function(
    $http) {


    return {
      downloadExport(exportName, params) {
        return presignedExport.downloadExport('/billingAccounts/export/' + exportName, params);
      },
      listBillingAccounts(params) {
        return $http.get('/billingAccounts', {
          params: params
        });
      },
      deactivate(_id) {
        return $http.delete(`/billingAccounts/${_id}`);
      },
      reactivate(_id, shouldReactivate) {
        return $http.post(`/billingAccounts/reactivate/${_id}`, {}, {
          params: {
            restoreSubscription: shouldReactivate
          }
        })
      },
      changeSubscriptionType(_id, type) {
        return $http.post(`/billingAccounts/${_id}/subscriptionType`, {}, {
          params: {
            subscriptionType: type
          }
        })
      },
      getBillingAccount(_id) {
        return $http.get(`/billingAccounts/${_id}`);
      },
      update(_id, data) {
        return $http.post(`/billingAccounts/${_id}`, data)
      },
      create(data) {
        return $http.put('/billingAccounts', data)
      },
      users(_id) {
        return $http.get('/billingAccounts/users/' + _id)
      },
      tags() {
        return $http.get('/billingAccounts/tags');
      },
      queryTags(q) {
        return this.tags().then((tags) => {
          return tags.data.filter((tag) => tag.toLowerCase().startsWith(q.toLowerCase()))
        });
      }
    }
  })
};
